import { Typography, Button, Anchor, Badge } from '@ui/components';
import { Routes } from '@shared/enums/routes.enum';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FC } from 'react';

const REDIRECT_URL = `../${Routes.TOP_UP_BALANCE}`;

export const OnboardingTopUpBalanceFailure: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <Typography variant="h400" element="h1">
        {t('ONBOARDING.TOP_UP.TITLE')}
      </Typography>

      <div className="flex flex-col items-center justify-center gap-7 p-12 border border-border-weak-hover rounded-xl">
        <Typography variant="h300" element="h3">
          {t('ONBOARDING.TOP_UP.PAYMENT_FAILURE_TITLE')}
        </Typography>
        <div className="flex items-center gap-2">
          <Typography variant="labelLargeBook" element="span">
            {t('ONBOARDING.TOP_UP.PAYMENT_STATUS')}
          </Typography>
          <Badge variant="red" size="large">
            {t('ONBOARDING.TOP_UP.REJECTED_STATUS')}
          </Badge>
        </div>
        <Anchor asChild>
          <Link to={REDIRECT_URL} replace>
            <Button>{t('ONBOARDING.TOP_UP.RETRY')}</Button>
          </Link>
        </Anchor>
      </div>
    </div>
  );
};
